"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRouterDom = require("react-router-dom");

var _Input = _interopRequireDefault(require("antd/lib/input/Input"));

class CmsPage extends _react.default.Component {
  render() {
    const {
      Search
    } = _Input.default;
    return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("span", null, "Content Library"), /*#__PURE__*/_react.default.createElement(Search, {
      enterButton: true,
      onSearch: value => console.log(value),
      placeholder: "search for content",
      style: {
        width: 200
      }
    }), /*#__PURE__*/_react.default.createElement("span", {
      style: {
        float: 'right'
      }
    }, "Add")), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("span", null, "Collections"), /*#__PURE__*/_react.default.createElement("span", null, "HMP Core")), /*#__PURE__*/_react.default.createElement("div", null, "List articles/search articles/categories/etc"), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
      to: "/admin/cms/article/new"
    }, "New Article"));
  }

}

var _default = CmsPage;
exports.default = _default;